export default {
  meet_brosmind: "Designers",
  about_guruzs: "Story",
  roadmap: "Roadmap",
  faq: "FAQs",
  team: "Team",
};
